import { useEffect } from 'react';
import { useFormik } from 'formik';
import { PqrStatusManagement } from '../../../../../../shared/types/modules/pqr';
import dayjs from 'dayjs';

export const usePqrDatesInfo = (
    datesInfo?: PqrStatusManagement,
    createdAt?: Date
) => {
    const formik = useFormik({
        initialValues: {
            customerFilingDate: null as dayjs.Dayjs | null,
            notificationProcedureDate: null as dayjs.Dayjs | null,
            processingDate: null as dayjs.Dayjs | null,
            suspensionDate: null as dayjs.Dayjs | null,
            sendEmailExpansionInformation: false,
            reactivationDate: null as dayjs.Dayjs | null,
            extensionDate: null as dayjs.Dayjs | null,
            sendEmailExtension: false,
            alertSFCDate: null as dayjs.Dayjs | null,
            responseDate: null as dayjs.Dayjs | null,
            sendEmailResponse: false,
            notificationResponseDate: null as dayjs.Dayjs | null,
            sacDate: null as dayjs.Dayjs | null,
            furagDate: null as dayjs.Dayjs | null,
            closingDate: null as dayjs.Dayjs | null,
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            customerFilingDate: datesInfo?.customerFilingDate
                ? dayjs(datesInfo?.customerFilingDate)
                : dayjs(createdAt).subtract(5, 'hours'),
            notificationProcedureDate: datesInfo?.notificationProcedureDate
                ? dayjs(datesInfo?.notificationProcedureDate)
                : dayjs(createdAt).subtract(5, 'hours'),
            processingDate: datesInfo?.processingDate
                ? dayjs(datesInfo?.processingDate)
                : null,
            suspensionDate: datesInfo?.suspensionDate
                ? dayjs(datesInfo?.suspensionDate)
                : null,
            sendEmailExpansionInformation:
                datesInfo?.sendEmailExpansionInformation || false,
            reactivationDate: datesInfo?.reactivationDate
                ? dayjs(datesInfo?.reactivationDate)
                : null,
            extensionDate: datesInfo?.extensionDate
                ? dayjs(datesInfo?.extensionDate)
                : null,
            sendEmailExtension: datesInfo?.sendEmailExtension || false,
            sendEmailResponse:
                datesInfo?.sendEmailExpansionInformation || false,
            alertSFCDate: datesInfo?.alertSFCDate
                ? dayjs(datesInfo?.alertSFCDate)
                : null,
            notificationResponseDate: datesInfo?.notificationResponseDate
                ? dayjs(datesInfo?.notificationResponseDate)
                : null,
            responseDate: datesInfo?.responseDate
                ? dayjs(datesInfo?.responseDate)
                : null,
            sacDate: datesInfo?.sacDate ? dayjs(datesInfo?.sacDate) : null,
            furagDate: datesInfo?.furagDate
                ? dayjs(datesInfo?.furagDate)
                : null,
            closingDate: datesInfo?.closingDate
                ? dayjs(datesInfo?.closingDate)
                : null,
        });
    }, [datesInfo]);

    return {
        formik,
    };
};
